import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { initTelegram } from './lib/telegram';

import '@tokens';
import '@tokens-site';
import './styles/app.css';
import './styles/site.css';

initTelegram();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Мобильная сеть рвётся: одна повторная попытка вместо трёх по умолчанию
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: { retry: 0 },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Не найден #root');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
